// token key
export const TOKEN_KEY = 'TOKEN__';

export const LOCALE_KEY = 'LOCALE__';

// 刷新Token key
export const REFRESH_TOKEN_KEY = 'REFRESH__TOKEN__';
// 租户ID key
export const TENANT_ID_KEY = 'TENANT__ID__';
// 应用id key
export const APPLICATION_ID_KEY = 'APPLICATION__ID__';
// 应用名称
export const APPLICATION_NAME_KEY = 'APPLICATION__NAME__';
// 用户信息 key
export const USER_INFO_KEY = 'USER__INFO__';

// 资源编码
export const PERM_CODE_KEY = 'PERM__CODE__';
// 权限编码
export const PERM_KEY = 'PERM__';
// 过期时间 key
export const EXPIRE_TIME_KEY = 'EXPIRE__TIME__';

// role info key
export const ROLES_KEY = 'ROLES__KEY__';

// project config key
export const PROJ_CFG_KEY = 'PROJ__CFG__KEY__';

// lock info
export const LOCK_INFO_KEY = 'LOCK__INFO__KEY__';

export const MULTIPLE_TABS_KEY = 'MULTIPLE_TABS__KEY__';

export const APP_DARK_MODE_KEY_ = '__APP__DARK__MODE__';

// base global local key
export const APP_LOCAL_CACHE_KEY = 'COMMON__LOCAL__KEY__';

// base global session key
export const APP_SESSION_CACHE_KEY = 'COMMON__SESSION__KEY__';

export enum CacheTypeEnum {
  SESSION,
  LOCAL,
}
